(function (angular, app) {
   "use strict";

   angular.module(app.modules.outing.name)
      .controller(app.modules.outing.routes.leaderboard.controller, OutingLeaderboardController);

   OutingLeaderboardController.$inject = ["$scope", "$timeout", "$routeParams", "$q"
      , app.modules.common.constants.appsettings
      , app.modules.outing.services.outings
      , app.modules.scoring.services.gamescore
      , app.modules.group.services.groups
      , app.modules.member.services.search
      , app.modules.common.services.functions
      , app.modules.common.services.storage
      , app.modules.ui.services.alerts
      , app.modules.common.constants.themelist
   ];

   function OutingLeaderboardController($scope, $timeout, $routeParams, $q
      , ggAppSettings
      , ggOutingSvc
      , ggScoringSvc
      , ggGroupSvc
      , ggMemberSearchSvc
      , ggFunctions
      , ggStorage
      , ggAlertSvc
      , ggThemes
   ) {

      var ctrl = this;


      // Scope Services
      $scope.PopupAlert = new ggAlertSvc.popup;
      
      $scope.Temp = {
         isLoaded: false
         , leaderboard: {
            isWagers: false
            , gameId: 0
            , roundId: 0
         }
         , roundDate: null
         , themes: ggThemes
      }

      $scope.Outing = null;
      $scope.Course = null;
      $scope.Round = null;
      $scope.View = {
         tabs: {
            current: 1
            , types: {
               leaderboard: 1
            }
            , isActive: function (tab) {
               return tab == $scope.View.tabs.current;
            }
            , select: function (tab) {
               $scope.View.tabs.current = tab;
               if (tab == $scope.View.tabs.types.leaderboard) {
                  $scope.Content.leaderboard.tabs.select(0);
               }
               $scope.View.tabs.current = tab;
            }
         }
      }

      $scope.Content = {
         init: function () {

            if ($scope.Outing) {
               $scope.View.tabs.select($scope.View.tabs.types.leaderboard);
               
            }
            $scope.Temp.isLoaded = true;
            ggFunctions.toggleProcessing(false);
         }
         , leaderboard: {
            gameId: 0
            , tabs: {
               current: 0
               , isActive: function (tab) {
                  return $scope.Content.leaderboard.tabs.current == tab;
               }
               , select: function (tab) {
                  if (tab > -1) {
                     $scope.Content.leaderboard.gameId = $scope.Outing.games[tab].id;
                  } else {
                     $scope.Content.leaderboard.gameId = 0;
                  }
                  $scope.Content.leaderboard.tabs.current = tab;
               }
            }
         }
      }

      $scope.f = {
         getTheme: function (themeId) {
            var rv = "";
            for (var x = 0; x < ggThemes.length; x++) {
               if (ggThemes[x].themeId == themeId) {
                  rv = ggThemes[x].className;
                  break;
               }
            }
            return rv;
         }
         , formatDateString: function (d) {
            return ggFunctions.formatDateString(d, 'm/d/yyyy', null)
         }
         , renderCourseName: function (courseId) {
            for (var x = 0; x < $scope.Outing.courses.length; x++) {
               if ($scope.Outing.courses[x].id == courseId) {
                  return $scope.Outing.courses[x].facilityName;
               }
            }
         }
         , renderTime: function (time) {
            return ggFunctions.parseDBTime(time);
         }
      }


      // Page Startup
      if ($routeParams) {
         if (!$routeParams.tk) {
            // No Outing Id.  Shame on you.
            $scope.Content.init();
         } else {
            var token = $routeParams.tk;
            var outingId = Number($routeParams.outingId);
            var isNew = false;
            var ttCnt = 1;
            var newOuting = {};

            // Outing
            var fetchOuting = function (token) {
               return ggOutingSvc.search.fetchOutingDetailByToken(token).then(function (data) {

                  newOuting = data.data;
                  outingId = data.data.id;
                  return;
               }, function (error) {
                  return;
               });
            }

            // Process
            ggFunctions.toggleProcessing(true);
            return fetchOuting(token).finally(function () {

               if (newOuting.id) {
                  $scope.Outing = newOuting;
               }
               $scope.Content.init();
            });
         }
      }

   }
}(angular, app));

